import { IGroupStanding, IGroupStandingList, RankedGroupTeam } from "../models/IGroup";

const byPerformance = (a: IGroupStanding, b: IGroupStanding) => {
  if (b.points !== a.points) return b.points - a.points;
  if (b.setsDifference !== a.setsDifference) return b.setsDifference - a.setsDifference;
  return b.pointDifference - a.pointDifference;
};

/**
 * Seeds every team of a group stage into one overall ranking: all group winners are
 * ranked against each other first, then all runners-up, and so on. This is the order
 * the knockout scheduler qualifies teams in, so it stays valid mid-stage too - it just
 * reflects the standings as they are right now.
 */
export const rankGroupTeams = (groupLists: IGroupStandingList[]): RankedGroupTeam[] => {
  const transposedByRank: IGroupStanding[][] = [];

  groupLists.forEach((group) => {
    const sorted = [...group.standings].sort(byPerformance);
    for (let i = 0; i < sorted.length; i++) {
      if (!transposedByRank[i]) transposedByRank[i] = [];
      if (sorted[i]) transposedByRank[i].push(sorted[i]);
    }
  });

  const rankedTeams: RankedGroupTeam[] = [];
  transposedByRank.forEach((positionGroup, position) => {
    [...positionGroup].sort(byPerformance).forEach((standing) => {
      rankedTeams.push({
        teamId: standing.teamId,
        teamName: standing.teamName,
        groupName: standing.groupName,
        position: position + 1,
        points: standing.points,
        setsDifference: standing.setsDifference,
        pointDifference: standing.pointDifference,
      });
    });
  });

  return rankedTeams;
};
